import { makeStyles } from '@mui/styles';

export const useItemStyles = makeStyles(({ palette, shape }) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    padding: '0.85rem',
    position: 'relative',

    '.small &': {
      padding: '0.5rem 1.0833333333rem',
    },

    '&:hover': {
      color: palette.primary.contrastText,
      background: palette.background.tableRowHover,

      '& svg [class*="svg-fill-"]': {
        fill: palette.primary.contrastText,
        color: palette.primary.contrastText,
      },

      '& svg': {
        fill: palette.primary.contrastText,
        color: palette.primary.contrastText,
      },
    },
  },

  selected: {
    color: `${palette.common.cowbellBlue} !important`,
    background: `${palette.background.tableRowHover} !important`,

    '& svg [class*="svg-fill-"]': {
      fill: palette.common.cowbellBlue,
    },

    '& svg': {
      fill: palette.common.cowbellBlue,
      color:
        palette.type === 'dark'
          ? palette.primary.contrastText
          : palette.common.cowbellBlue,
    },

    '&:hover': {
      background: `${palette.background.tableRowHover} !important`,
      color: palette.common.cowbellBlue,
    },

    '&:hover svg': {
      fill: palette.common.cowbellBlue,
    },

    '&::after': {
      content: '""',
      width: 5,
      height: '100%',
      position: 'absolute',
      top: 0,
      left: 0,
      backgroundColor: palette.common.cowbellBlue,
      borderRadius: shape.borderRadius,
    },
  },
}));

// Shared across EVERY persona's sidebar (also BottomNavigation /
// RenderMuiListItem). Kept at its original sizing so non-Cowbell personas are
// untouched — the Cowbell-only icon restyle (uniform size + soft grey + line
// treatment) lives in Sidebar.tsx's `cowbellNav` class, scoped to the Cowbell
// sidebar so it can't spill here.
export const useIconStyles = makeStyles(() => ({
  root: {
    '& svg': {
      minWidth: 'unset',
      maxWidth: '100%',
      width: '2.0833333333rem',
      height: '2.0833333333rem',
    },

    '.small & svg': {
      width: '1.6666666667rem',
      height: '1.6666666667rem',
    },
  },
}));

export const useItemTextStyles = makeStyles(({ config }) => ({
  root: {
    fontSize: config.textSizes.tertia,
    marginTop: 0,
    marginBottom: 0,
    marginLeft: 3,

    '.small &': {
      fontSize: config.textSizes.petite,
    },
  },
}));

export const useSecondaryNavIcon = makeStyles(({ palette }) => ({
  root: {
    position: 'relative',
    top: 2,
    left: 2,
    color: palette.mode === 'dark' ? '#494949' : '#f0f0f0',
  },
}));

export const useGroupLabelStyles = makeStyles(({ config }) => ({
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '0.625rem 0.85rem 0.1875rem',
    cursor: 'pointer',
  },

  label: {
    fontSize: '0.65rem',
    fontWeight: 700,
    textTransform: 'uppercase',
    letterSpacing: '0.07em',
    color: config.colors.darkGrey3,
    padding: 0,
    lineHeight: 'normal',
  },

  chevron: {
    color: config.colors.darkGrey3,
    transition: 'transform 150ms ease',
  },

  collapsed: {
    transform: 'rotate(-90deg)',
  },
}));
